import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  targetUserIdSelector,
  targetUserSelector,
} from '../../../redux/context/selectors';
import {
  familyCircleSelector,
  selectPendingFamilyMembers,
  sendingReqCircleOfCareSelector,
} from '../../../redux/board/selectors/circleOfCare';
import { selectIsAccessLeverProvider } from '../../../redux/profiles/selectors';
import withPopoverMenu from '../../../hocs/withPopoverMenu';
import transformDataErrors from '../utils/transformDataErrors';
import circleOfCareSaga from '../../../redux/circles/sagas/circle-of-care';
import { actions as inviteToFamilyCircleActions } from '../../../redux/circles/inviteToFamilyCircle';
import { actions as changeMemberRoleActions } from '../../../redux/circles/change-member-role-req';
import { actions as leaveFamilyCircleActions } from '../../../redux/circles/leaveFamilyCircle';
import { RESTART_ON_REMOUNT } from '../../../redux/sagaInjectors';
import { circleActions } from '../../../redux/circles/actions';
import {
  selectErrorInviteToFamilyCircle,
  selectSucceedFamilyCircleReq,
  selectRejectedFamilyCircleReq,
  selectCircleLoadingState,
} from '../../../redux/circles/selectors';
import injectSaga from '../../../redux/injectSaga';
import { actions as invitePatientActions } from '../../../redux/board/reqInvitePatient';

const mapStateToProps = state => ({
  targetUser: targetUserSelector(state),
  targetUserId: targetUserIdSelector(state),
  familyCircle: familyCircleSelector(state),
  loadingCircle: sendingReqCircleOfCareSelector(state),
  isProvider: selectIsAccessLeverProvider(state),
  inviteToFamilyCircleErrors: selectErrorInviteToFamilyCircle(state),
  circleLoading: selectCircleLoadingState(state),
  succeedFamilyCircleReq: selectSucceedFamilyCircleReq(state),
  rejectedFamilyCircleReq: selectRejectedFamilyCircleReq(state),
  pendingFamilyMembers: selectPendingFamilyMembers(state),
});

const mapDispatchToProps = {
  inviteFamilyMember: circleActions.inviteToFamilyCircle,
  changeRole: circleActions.changeRole,
  removeFamilyMember: circleActions.removeMember,
  clearInviteToFamilyCircle: inviteToFamilyCircleActions.clear,
  clearLeaveFamilyCircle: leaveFamilyCircleActions.clear,
  clearChangeMemberRole: changeMemberRoleActions.clear,
  clearPatientInviteReq: invitePatientActions.clear,
};

export const enhance = compose(
  injectSaga({
    key: 'circleOfCareSaga',
    saga: circleOfCareSaga,
    mode: RESTART_ON_REMOUNT,
  }),
  withPopoverMenu,
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(
    ({
      inviteToFamilyCircleErrors,
      succeedFamilyCircleReq,
      rejectedFamilyCircleReq,
      clearInviteToFamilyCircle,
      clearLeaveFamilyCircle,
      clearChangeMemberRole,
      invitePatientSucceed,
      clearPatientInviteReq,
    }) => {
      // in case if we have already assigned an error code, we show error popup
      // other errors handle form validation
      const inviteMemberErrors = transformDataErrors(
        inviteToFamilyCircleErrors,
      );
      return {
        shouldClear:
          succeedFamilyCircleReq ||
          invitePatientSucceed ||
          (rejectedFamilyCircleReq && !inviteMemberErrors),
        inviteMemberErrors,
        clearRequests: () => {
          clearInviteToFamilyCircle();
          clearLeaveFamilyCircle();
          clearChangeMemberRole();
          clearPatientInviteReq();
        },
      };
    },
  ),
);



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/FamilyCircleWrapper/enhance.js